import { render, staticRenderFns } from "./StrategyCompare.vue?vue&type=template&id=62d8ec7d&scoped=true"
import script from "./StrategyCompare.vue?vue&type=script&lang=js"
export * from "./StrategyCompare.vue?vue&type=script&lang=js"
import style0 from "./StrategyCompare.vue?vue&type=style&index=0&id=62d8ec7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d8ec7d",
  null
  
)

export default component.exports